import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar'
import SustainbilitySection from '../../SustainbilitySection/SustainbilitySection'
import Footer2 from '../../Footer2/Footer2'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const Sustainbility = () => {
    return (
        <div>
            <TopBar/>
            <Navbar />
            <SustainbilitySection />
            <Footer2/>
        </div>
    )
}

export default Sustainbility
